<template>
    <div class="main">
        <div class="map" id="map"></div>
    </div>
</template>

<script>
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import {tiledMapLayer} from '@supermap/iclient-leaflet'
import LeafletDraw from 'leaflet-draw'
import 'leaflet-draw/dist/leaflet.draw.css'
export default {
    data(){
        return{

        }
    },
    methods:{
        initMap(){
            console.log(LeafletDraw);
            var url = "https://iserver.supermap.io/iserver/services/map-world/rest/maps/World";
            var map = L.map('map', {
                crs: L.CRS.EPSG4326,
                center: [0, 0],
                maxZoom: 18,
                zoom: 1,
            });
            tiledMapLayer(url).addTo(map);

            const drawnItems = new L.FeatureGroup()
            map.addLayer(drawnItems)
            const drawControl = new L.Control.Draw({
            edit: {
                featureGroup: drawnItems
            }
            })
            map.addControl(drawControl)
    
        }
    },
    mounted(){
        this.initMap()
    }
}
</script>

<style lang="scss" scoped>
.map{
    width: 800px;
    height: 800px;
}
</style>